import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { TagValueBadge } from './tag-value-badge'

interface DeleteResourceTagDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  resourceTag: string
  tagValue: string
  onConfirm: () => void
  isLoading?: boolean
}

export function DeleteResourceTagDialog({
  open,
  onOpenChange,
  resourceTag,
  tagValue,
  onConfirm,
  isLoading = false,
}: DeleteResourceTagDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Data Classification</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm text-muted-foreground">
              <p>
                Are you sure you want to delete{' '}
                <code className="rounded bg-muted px-1 py-0.5 font-mono text-foreground">
                  {resourceTag}
                </code>{' '}
                <TagValueBadge value={tagValue} className="align-middle" />?
              </p>
              <p>
                This soft-deletes the classification and its records. Policies that rely
                on it may be affected.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
